import React, { useContext, useEffect, useState } from 'react';
import "./RoomList.css"
import RoomService from "../../service/RoomService";
import { Context } from "../../index";
import $ from "jquery";
import Spin from "../../components/UI/Spin/Spin";
import { observer } from 'mobx-react-lite';
import ErrorComponent from '../../components/UI/Error/ErrorComponent';
import {useNavigate} from "react-router-dom"
import {NAME_HOST_GAME, NAME_SERVER} from "../../Utils/NAME_HOST";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
// import '../RegForm/RegForm.css';
import google from "../../Pages/RegForm/google.png";
import vk from "../../Pages/RegForm/vk.png";
import Footer from "../../components/Footer/Footer";
import {fillTextPage} from "../../Utils/FillTextPage";
const RoomList = () => {
    const { store } = useContext(Context);
    const [sort, setSort] = useState("online");
    const [lastId , setLastId] = useState("")
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [error, setError] = useState("");
    const [statusErrorChange,setStatusErrorChange] = useState(false);

    const [status_load , setStatus_load] = useState(0)
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [rooms, setRooms] = useState([]);
    const [pages, setPages] = useState([]);
    const [curNameRoom , setcurNameRoom] = useState("")
    const [showRooms, setShowRooms] = useState(false);
    const [searchActive, setSearchActive] = useState(false);
    const navigate = useNavigate();
    const [goldRoom  ,setGoldRoom] = useState(null)
    const [bonusRoom , setBonusRoom] = useState(null);
    const [loadRoomChecked , setLoadRoomChecked] = useState(false);
    const [ authChecked, setAuthChecked] = useState(false)

    function formatCurrency(amount , type="real"){
        const currency = 'RUB';

        const formatter = new Intl.NumberFormat('ru-RU', {
            style: 'currency',
            currency: currency,
        });

        let formattedAmount = formatter.format(amount);
        if (type === "bonus"){
            formattedAmount = formattedAmount.replace("₽" , "B")
        }
        return formattedAmount.replace(",00",'')
    }
    // async function changeOnline(){
    //     const roomsNew =(await RoomService.getOnline()).data;
    //     const RoomsNow = document.querySelectorAll(".online").forEach(el=>{
    //         const name = el.getAttribute("name")
    //         el.innerHTML=roomsNew[name] + `
    //
    //         <span
    //           className={room.online < 30 ? "pulse-circle" : "pulse-circle red"}></span>
    //
    //         `
    //     })
    //
    //
    //
    // }
    const renderTooltip = (props , text) => (

        <Tooltip id="button-tooltip" {...props}>

        </Tooltip>
      );
    useEffect(() => {

        if (error.length>0){
            store.add_message(error,ErrorComponent)
        }
    }, [statusErrorChange]);
    useEffect(()=>{
        if (store.isAuth){

            setAuthChecked(true);

        }

    } , [store.isAuth])
    const updateRooms = async ()=>{
        const response = await store.getRoom_listCost(1, sort)
        setRooms(response);
    }
    const fetchRoomsBySort = async(sortBy)=>{
        try {


            const response = await store.getRoom_listCost(page, sortBy)
            setRooms(response);
            setLoadRoomChecked(true)
        }
        catch (e){
            setError("error1")
            setStatusErrorChange(!statusErrorChange)


        }
        finally {
            setLoadRoomChecked(true)

        }
    }
    const fetchRoomsByPage = async(pageBy)=>{
        try {


            const response = await store.getRoom_listCost(pageBy, sort)
            setRooms(response);
            setLoadRoomChecked(true)
        }
        catch (e){
            setError("error1")
            setStatusErrorChange(!statusErrorChange)


        }
        finally {
            setLoadRoomChecked(true)

        }
    }
    const fetchRooms = async () => {
        try {


            const response = await store.getRoom_listCost(page, sort)
            const len = await RoomService.getLengthRoom();
            const goldr = await store.getInfRoom("gold")
            const bonusr = await store.getInfRoom("bonus")
            setGoldRoom(goldr)
            setBonusRoom(bonusr)
            setRooms(response);

            renderPagination(totalPages(len.data));
            setLoadRoomChecked(true)
        }
        catch (e){
            setError("error1")
            setStatusErrorChange(!statusErrorChange)


        }
        finally {
            setLoadRoomChecked(true)

        }

    };
    useEffect(() => {
        // setInterval(()=>{
        //     updateRooms()
        // } , 5000)
        const checkStatus = async ()=>{
            const resp = await RoomService.check_status_game();

            if (resp.data.on){
                setStatus_load(1)

            }
            else{
                setError("error2")
                setStatusErrorChange(!statusErrorChange)

            }

        }
        fillTextPage("money_rooms",store)
        checkStatus()


        fetchRooms();
    }, []);

    // useEffect(() => {
    //     const fetchRooms = async () => {
    //         try {
    //
    //
    //             const response = await store.getRoom_listCost(page, sort)
    //             setRooms(response);
    //
    //             //renderPagination(totalPages(response.length));
    //             setLoadRoomChecked(true)
    //         }
    //         catch (e){
    //             //console.log("Ошикбкакакака")
    //             setError("error1попробуйте чуть позже")
    //
    //         }
    //         finally {
    //             setLoadRoomChecked(true)
    //
    //         }
    //     };
    //     fetchRooms();
    //
    // }, [sort, page]);

    useEffect(() => {

        const fetchRoomsByName = async () => {
            try {
                const response = await RoomService.getRoom_byName(search);
                setRooms(response.data);
            } catch (e){
                setError("error1")
                setStatusErrorChange(!statusErrorChange)


            }

        };

        fetchRoomsByName();
    }, [search]);

    useEffect(() => {
        if (rooms){
            setShowRooms(rooms.length > 0);

        }
    }, [rooms]);
    useEffect(() => {
        if (!store.isLoading){
            store.setIsLoadingComponent(false)

        }
    }, [store.isLoading]);

    async function fetchData(room , choice) {
        try {
            // store.setIsLoading(true);
            const roomData = await RoomService.getRoomData(room , choice);

            if (roomData.data.err==="cost"){
                setTimeout(()=>{
                    navigate("/pay")
                } , 2000)
                setStatusErrorChange(!statusErrorChange)

                return setError(`error8`);


            }
            if (roomData.data.name) {
                if ((roomData.data.cost > store.user.balance && choice=="real") || (roomData.data.cost > store.user.bonus && choice=="bonus")) {
                    setTimeout(()=>{
                        navigate("/pay")
                    } , 1000)
                    setStatusErrorChange(!statusErrorChange)

                    return setError(`error8`);

                    // setTimeout(() => setError(""), 3000); // Clear error after 3 seconds
                }
                if (roomData.data.online > 30){
                    setStatusErrorChange(!statusErrorChange)

                    return setError("error7")
                }

                if (room === "bonus") {
                    window.location.replace(NAME_HOST_GAME+"/game?choice="+choice);

                }
                else{
                    window.location.replace(NAME_HOST_GAME+"/game");

                }
            } else {
                setStatusErrorChange(!statusErrorChange)

                return setError(roomData.data.err);

                //setTimeout(() => setError(""), 3000); // Clear error after 3 seconds
            }
        } catch (e) {
            setStatusErrorChange(!statusErrorChange)

            setError("error1")
        } finally {
            // store.setIsLoading(false);
        }
    }

    async function handleClick(name) {
        setcurNameRoom(name)

        if (name === "bonus") {


            document.querySelector(".content_room_list").style.opacity = 0.1;
            setIsModalOpen(true)

        }
        else{
            FetchChouiceConnect("real" , name)
        }

    }

    function handleSortChange(sortType) {
        setSort(sortType);
        fetchRoomsBySort(sortType)

    }
    const closeModal = () => {
        document.querySelector(".content_room_list").style.opacity=1;
        setIsModalOpen(false);
    };
    const totalPages = (count_rooms) => {
        const pages_bf = count_rooms

        return Math.floor(pages_bf / 10) + Number(pages_bf % 10 !== 0);
    };

    const getPages = async () => {
        return await totalPages();
    };

    function handlePageChange(newPage) {
        setPage(newPage);
        fetchRoomsByPage(newPage)

    }

    const renderPagination = async (totalPages) => {
        try {
            const totalPg = totalPages;
            const pages = [];
            for (let i = 1; i <= totalPg; i++) {
                pages.push(
                    <button
                        key={i}
                        className={page === i ? "active" : "page"}
                        onClick={() => handlePageChange(i)}
                    >
                        {i}
                    </button>
                );
            }
            setPages(pages);
        } catch (e) {
            setStatusErrorChange(!statusErrorChange)

            setError("error1")
        }
    };
    const searchToggle = (evt) => {
        if (!searchActive) {
            setSearchActive(true);
            evt.preventDefault();
        } else if (searchActive && !evt.target.closest('.input-holder')) {
            setSearchActive(false);
            // clear input
            setSearch('');
        }
    };
    const handleSearchInputChange = (e) => {
        setSearch(e.target.value);
    };
    const handleSearchButtonClick = () => {
        setSearchActive(true)
        // Perform search action here
    };
    const handleClearSearch = async () => {
        const response = await RoomService.getRoom_listCost(page, sort);
        const data = response.data;
        setRooms(data);
        setSearchActive(false);
    };
    async function FetchChouiceConnect(choice,room=null){
        try {
            if (store.user.login){
                if (room) {
                    await fetchData(room , choice);

                }
                else{
                    await fetchData(curNameRoom , choice);

                }

            }
            else{
                navigate("")
            }


        } catch (e) {
            setStatusErrorChange(!statusErrorChange)

            setError("error1")
        } finally {
            store.setIsLoading(false);
        }
    }
    if (store.isLoading){
        return (<Spin/>)
    }
    if (!loadRoomChecked){
        return (<Spin/>)
    }
    if (authChecked){
        if (store.isLoading){

            return (
                <>
                {<Spin/>}
                </>
            )
        }
        if (!status_load){
            return (
                <>

                    {<Spin/>}
                </>
            )
        }
        else {


            if (!store.isLoading && store.user.login) {

                return (
                    <>

                        {store.isLoading ? (
                            <Spin/>
                        ) : (
                            <div>
                                {isModalOpen&& (
                                    <div className="modal-container">
                                        <div className="login-box">
                                            <span></span>
                                            <span></span>
                                            <span></span>

                                            <form onSubmit={(e)=>{
                                                e.preventDefault()
                                            }}>

                                                <h2 className="enter_model_h2">Войти за</h2>
                                                <div className="buttons_choice" style={{display:"flex"}}>
                                                    <button className="real-cash-button" onClick={()=>FetchChouiceConnect("real")}>
                                                        {store.dataLang["money_rooms_text1"]}
                                                    </button>
                                                    <button className="bonus-cash-button" onClick={()=>FetchChouiceConnect("bonus")}>
                                                        {store.dataLang["money_rooms_text2"]}
                                                    </button>
                                                </div>
                                                <div style={{display:"flex"}}>

                                                <p style={{margin: "10px", marginLeft:"auto"}}>{store.dataLang["money_rooms_text3"]} <span style={{color:"greenyellow"}}>{formatCurrency(store.user.balance)}</span></p>
                                                    <p style={{margin:"10px",marginRight:"auto"}}>{store.dataLang["money_rooms_text3"]} <span style={{color:"#5C62EC"}}>{formatCurrency(store.user.bonus,"bonus")}</span></p>

                                                </div>


                                                {/*<ReCAPTCHA*/}
                                                {/*    sitekey="6LeROBooAAAAAFgL6IfH4WBR9gv6xmfBwL-ZYv7Q"*/}
                                                {/*    onChange={changer}*/}
                                                {/*/>*/}
                                                {/*<button onClick={()=>{const a="1"}}>*/}
                                                {/*    Войти c помощью*/}
                                                {/*</button>*/}
                                                {/*<div className="dop">*/}
                                                {/*    <div className="dot_length enter"></div>*/}
                                                {/*    <h3>Войти с помощью</h3>*/}
                                                {/*    <div className="dot_length enter"></div>*/}
                                                {/*</div>*/}


                                            </form>
                                        </div>
                                    </div>
                                )}

                            <div className="content_room_list" onClick={(e)=>{
                                if (isModalOpen) {

                                    setIsModalOpen(false)
                                    document.querySelector(".content_room_list").style.opacity = 1;
                                }

                            }}>

                                <div className="sidebar">
                                    <button onClick={() => handleSortChange("ASC")}>{store.dataLang["money_rooms_text4"]}</button>


                                    <button onClick={() => handleSortChange("DESC")}>{store.dataLang["money_rooms_text5"]}</button>
                                    <button onClick={() => handleSortChange("online_sort")}>{store.dataLang["money_rooms_text6"]}</button>
                                </div>
                                <div className="second_list">
                                    <div className="search_box room">
                                        <div className="search-wrapper active">
                                            <div className="input-holder">
                                                <input onChange={e => setSearch(e.target.value)} type="text"
                                                       className="search-input active"
                                                       placeholder={store.dataLang["placeholder_enter_room"]}/>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="ico">
                                        <i className="fa fa-refresh" style={{cursor:"pointer"}} aria-hidden="true" onClick={updateRooms}></i>

                                    </div>

                                </div>
                                <div style={{display:"flex",justifyContent:"center" , gap:"30px",flexWrap:"wrap"}} className="specials_room_container">

                                    <div className="container-gold-room">

                                        <div className="content-gold-room">
                                            {/*<span></span>*/}
                                            {/*<span></span>*/}
                                            {/*<span></span>*/}

                                            {/*<form onSubmit={(e)=>{*/}
                                            {/*    e.preventDefault()*/}
                                            {/*}}>*/}
                                            <div className="elements" style={{display:"flex",flexDirection:"column" , gap:"10px",alignItems:"center"}}>
                                                <div className="tooltip-container">
                                                    <span style={{width:"300px"}} dangerouslySetInnerHTML={{ __html: store.dataLang["money_rooms_text7_html"] }} className="tooltip-text gold"></span>

                                                    <h2 style={{fontSize:"28px"}}>GOLDEN ROOM</h2>
                                                </div>

                                                {/*<p></p>*/}
                                                {/*    <p></p>*/}
                                                {/*    */}

                                                <button className="buttonConnectGold" onClick={()=>{
                                                    FetchChouiceConnect("real" , "gold")
                                                }}>
                                                    <span><span style={{color:"white"}}>{store.dataLang["enter_name_title"].toUpperCase()}</span> {formatCurrency(goldRoom.cost)}</span>
                                                </button>

                                                {/*<ReCAPTCHA*/}
                                                {/*    sitekey="6LeROBooAAAAAFgL6IfH4WBR9gv6xmfBwL-ZYv7Q"*/}
                                                {/*    onChange={changer}*/}
                                                {/*/>*/}
                                                {/*<button onClick={()=>{const a="1"}}>*/}
                                                {/*    Войти c помощью*/}
                                                {/*</button>*/}
                                                {/*<div className="dop">*/}
                                                {/*    <div className="dot_length enter"></div>*/}
                                                {/*    <h3>Войти с помощью</h3>*/}
                                                {/*    <div className="dot_length enter"></div>*/}
                                                {/*</div>*/}
                                            </div>



                                        </div>
                                        {/*<h2 style={{textAlign:"center"}}>Золотая комната</h2>*/}
                                        {/*<div className="spans">*/}
                                        {/*    <p>Золотая комната спавнит каждые 6-10 минут определенное количество еды</p><br/>*/}
                                        {/*    <p>C помощью которой вы можете заработать даже без людей в комнате</p>*/}

                                        {/*</div>*/}
                                        {/*<p style={{textAlign:"center"}}>{formatCurrency(goldRoom.cost)}</p>*/}

                                        {/*<div style={{display:"flex",justifyContent:"center", marginTop:"10px"}}>*/}
                                        {/*    <button className="buttonConnectGold" onClick={()=>*/}

                                        {/*        FetchChouiceConnect("real","gold")}*/}
                                        {/*    >Подключиться*/}
                                        {/*    </button>*/}
                                        {/*</div>*/}

                                        {/*</div>*/}
                                    </div>
                                    <div className="container-gold-room">

                                        <div className="content-bonus-room">
                                            {/*<span></span>*/}
                                            {/*<span></span>*/}
                                            {/*<span></span>*/}

                                            {/*<form onSubmit={(e)=>{*/}
                                            {/*    e.preventDefault()*/}
                                            {/*}}>*/}
                                            <div className="elements" style={{display:"flex",flexDirection:"column" , gap:"10px",alignItems:"center"}}>
                                                <div className="tooltip-container">
                                                    <span style={{width:"300px"}} className="tooltip-text bonus" dangerouslySetInnerHTML={{ __html: store.dataLang["money_rooms_text8_html"] }}></span>

                                                    <h2 style={{fontSize:"28px"}}>BONUS ROOM</h2>
                                                </div>

                                                {/*<p></p>*/}
                                                {/*    <p></p>*/}
                                                {/*    */}
                                                <button className="buttonConnectGold" onClick={() => handleClick("bonus")}>
                                                    <span><span style={{color:"white"}}>{store.dataLang["enter_name_title"].toUpperCase()}</span> {formatCurrency(bonusRoom.cost)}</span>
                                                </button>

                                                {/*<ReCAPTCHA*/}
                                                {/*    sitekey="6LeROBooAAAAAFgL6IfH4WBR9gv6xmfBwL-ZYv7Q"*/}
                                                {/*    onChange={changer}*/}
                                                {/*/>*/}
                                                {/*<button onClick={()=>{const a="1"}}>*/}
                                                {/*    Войти c помощью*/}
                                                {/*</button>*/}
                                                {/*<div className="dop">*/}
                                                {/*    <div className="dot_length enter"></div>*/}
                                                {/*    <h3>Войти с помощью</h3>*/}
                                                {/*    <div className="dot_length enter"></div>*/}
                                                {/*</div>*/}
                                            </div>



                                        </div>
                                        {/*<h2 style={{textAlign:"center"}}>Золотая комната</h2>*/}
                                        {/*<div className="spans">*/}
                                        {/*    <p>Золотая комната спавнит каждые 6-10 минут определенное количество еды</p><br/>*/}
                                        {/*    <p>C помощью которой вы можете заработать даже без людей в комнате</p>*/}

                                        {/*</div>*/}
                                        {/*<p style={{textAlign:"center"}}>{formatCurrency(goldRoom.cost)}</p>*/}

                                        {/*<div style={{display:"flex",justifyContent:"center", marginTop:"10px"}}>*/}
                                        {/*    <button className="buttonConnectGold" onClick={()=>*/}

                                        {/*        FetchChouiceConnect("real","gold")}*/}
                                        {/*    >Подключиться*/}
                                        {/*    </button>*/}
                                        {/*</div>*/}

                                        {/*</div>*/}
                                    </div>
                                </div>


                                <div className="content_table">
                                    {showRooms ? (
                                        <table className={showRooms ? "fade" : ""}>
                                            <thead>
                                            <tr>
                                                <th>{store.dataLang["th_name_room"]}</th>
                                                <th>{store.dataLang["price_th"]}</th>
                                                <th>{store.dataLang["th_name_count"]}</th>
                                                <th>{store.dataLang["th_name_action"]}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {rooms.map((room) => (
                                                <tr key={room.id}>


                                                    <td style={{cursor:room.name==="bonus"?"pointer":"initial" , color:room.name==="bonus"?"#5C62EC":"white",fontStyle:`Montserrat,sans-serif`}}>{room.name}</td>
                                                    <td className={`balanceRoom`}><span>{formatCurrency(room.cost)}</span>
                                                    </td>
                                                    <td>
                                                <span className={`online`} name={room.name}>
                                                    {room.online}
                                                    <span
                                                        className={room.online < 30 ? "pulse-circle" : "pulse-circle red"}></span>
                                                </span>
                                                    </td>
                                                    <td>
                                                        <button class="buttonConnect"
                                                                onClick={() => handleClick(room.name)}>{store.dataLang["buttonConnect"]}
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <h1 className="fade">{store.dataLang["error4"]}</h1>
                                    )}
                                </div>
                                <div className="pagination">{pages}</div>
                            </div>
                                <Footer/>
                            </div>
                        )}

                    </>
                );
            } else {
                return (<Spin/>)
            }
            if (!store.isLoading && !store.user.login) {
                return (
                    <>
                        {<Spin/>}

                    </>
                )
            }
        }
    }

};

export default observer(RoomList);
